/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TripsIdIndexRouteImport } from './routes/trips/$id/index'

const TripsIdIndexRoute = TripsIdIndexRouteImport.update({
  id: '/trips/$id/',
  path: '/trips/$id/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/trips/$id/': typeof TripsIdIndexRoute
}
export interface FileRoutesByTo {
  '/trips/$id': typeof TripsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/trips/$id/': typeof TripsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/trips/$id/'
  fileRoutesByTo: FileRoutesByTo
  to: '/trips/$id'
  id: '__root__' | '/trips/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  TripsIdIndexRoute: typeof TripsIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trips/$id/': {
      id: '/trips/$id/'
      path: '/trips/$id'
      fullPath: '/trips/$id/'
      preLoaderRoute: typeof TripsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  TripsIdIndexRoute: TripsIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
